import * as singleSpa from "single-spa";

export function getActiveApps() {
	let activeApps = [];
	let apps = singleSpa.getAppNames();
	for (const app of apps) {
		const appStatus = singleSpa.getAppStatus(app);
		if (appStatus === "MOUNTED") {
			activeApps.push(app);
		}
	}
	return activeApps;
}
